import { FormatMoney } from '../../../hooks/useMoney';
import LangEnum from '../../../lang/LangEnum';
import { BusinessPolicyVoucherDTO } from '../../../services/modules/business-policies/businessPolicies.types';
import { formatDate } from '../../../utils/dates';
import { BusinessPolicyDiscountType } from '../../business-policies/enums/business-policy-discount-type.enum';
import { TranslateType } from '../../translation/translationContext.types';
import { OrderConditionBusinessPolicyVoucher } from './orderCondition.types';

const VOUCHER_DATE_FORMAT = 'dd/MM p';

export const VOUCHER_DISCOUNT_TYPE_RULES: Record<BusinessPolicyDiscountType, LangEnum[]> = {
  [BusinessPolicyDiscountType.PERCENTAGE]: [
    LangEnum.BUSINESS_POLICY_VOUCHER_ORDER_CONDITION_PERCENTAGE_RULE,
    LangEnum.BUSINESS_POLICY_VOUCHER_NO_FUTURE_BALANCE_RULE,
  ],
  [BusinessPolicyDiscountType.VALUE]: [
    LangEnum.BUSINESS_POLICY_VOUCHER_ORDER_CONDITION_FIXED_VALUE_RULE,
    LangEnum.BUSINESS_POLICY_VOUCHER_NO_FUTURE_BALANCE_RULE,
  ],
  [BusinessPolicyDiscountType.FIXED_VALUE_FROM_PERCENTAGE]: [
    LangEnum.BUSINESS_POLICY_VOUCHER_NO_FUTURE_BALANCE_RULE,
  ],
};

export const getVoucherDiscountLabel = (
  { discountType, discountValue }: BusinessPolicyVoucherDTO,
  formatMoney: FormatMoney,
) => {
  if (discountType === BusinessPolicyDiscountType.PERCENTAGE) {
    return `${discountValue}%`;
  }

  return discountValue ? formatMoney(discountValue) : '';
};

export const formatOrderConditionVoucher = (
  voucher: BusinessPolicyVoucherDTO | undefined,
  formatMoney: FormatMoney,
) => {
  if (!voucher) {
    return '';
  }

  const discountLabel = getVoucherDiscountLabel(voucher, formatMoney);

  return discountLabel ? `${voucher.name} (${discountLabel})` : voucher.name;
};

export const getVoucherDetailLabel = (
  voucher: OrderConditionBusinessPolicyVoucher,
  translate: TranslateType,
) => {
  if (voucher.applicationDate) {
    return translate(LangEnum.GLOBAL_APPLIED_IN, {
      appliedDate: formatDate(voucher.applicationDate, VOUCHER_DATE_FORMAT),
    });
  }

  const startDate = formatDate(voucher.startDate, VOUCHER_DATE_FORMAT);
  const expirationDate = formatDate(voucher.endDate, VOUCHER_DATE_FORMAT);

  if (startDate && expirationDate) {
    return `${translate(LangEnum.BUSINESS_POLICY_VOUCHERS_VALID_FROM_LABEL)} ${startDate} ${translate(LangEnum.GLOBAL_TO)} ${expirationDate}`;
  }

  if (startDate) {
    return `${translate(LangEnum.BUSINESS_POLICY_VOUCHERS_VALID_SINCE_LABEL)} ${startDate}`;
  }

  if (expirationDate) {
    return `${translate(LangEnum.BUSINESS_POLICY_VOUCHERS_VALID_UNTIL_LABEL)} ${expirationDate}`;
  }

  return translate(LangEnum.BUSINESS_POLICY_VOUCHERS_NO_EXPIRATION_DATE);
};
